<template>
  <div class="suggest-budget">
    <span v-if="pricing" class="c-budget c-budget-load">
      <Icon type="ios-loading" size="16" class="c-loading" />
      <span>正在计算建议预算...</span>
    </span>
    <span v-else-if="suggestedBid">建议日预算 {{ suggestedBid }} 元</span>
    <span v-else class="c-budget">建议日预算 {{ min }}-{{ max }} 元</span>
  </div>
</template>
<script>
export default {
  name: 'suggest-budget',
  props: {
    value: {
      type: Array,
      required: true
    },
    pricing: {
      type: Boolean,
      default: false
    },
    plan: {
      type: Object
    },
    suggestedBid: {
      type: Number
    },
    out: {
      type: Object,
      default() {
        return {}
      }
    },
    not: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    min() {
      return this.value[0] || 0
    },
    max() {
      return this.value[1] || 0
    }
  },
  watch: {
    out: {
      handler(nVal) {
        this.$emit('on-refresh')
      },
      deep: true
    },
    plan: {
      handler(nVal) {
        !this.not && this.$emit('on-refresh')
      },
      deep: true
    }
  },
  mounted() {
    this.$emit('on-refresh')
  }
}
</script>
<style lang="scss" scoped>
.suggest-budget {
  color: #ff4400;
  padding: 8px 0;

  .c-budget {
    line-height: 20px;
  }

  .c-budget-load {
    color: #999;
  }
}

.c-loading {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
